import requestActionFactory from 'common/actions/requestActionFactory';
import DataV2 from 'common/DataV2';

import type { IdeaTheme, IdeasConfiguration } from 'common/api/endpoints/idea';
import type { Dispatch, GetState, State } from 'redux-connect';

export { defaultState } from 'common/reducers/requestReducerFactory';

// Action Types

const {
  requestAction: configurationRequested,
  loadedAction: configurationLoaded,
  errorAction: configurationError,

  RequestType,
  LoadedType,
  ErrorType,
} = requestActionFactory<IdeasConfiguration>('ideasConfiguration');

// Action Creators

function fetchConfiguration() {
  return async (dispatch: Dispatch, getState: GetState) => {
    const cookies = getState().cookies;
    try {
      const response = await DataV2.fetch(DataV2.queries.ideasConfiguration, {}, cookies);
      return dispatch(configurationLoaded(response));
    } catch (error) {
      if (typeof error === 'string') {
        return dispatch(configurationError(error));
      }
      return dispatch(configurationError('server error'));
    }
  };
}

export function loadConfiguration() {
  return (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    if (shouldFetch(state)) {
      dispatch(configurationRequested());
      return dispatch(fetchConfiguration());
    }

    return Promise.resolve();
  };
}

export function reloadConfiguration() {
  return (dispatch: Dispatch) => {
    return dispatch(fetchConfiguration());
  };
}

// Helpers

export function shouldFetch(state: State) {
  return !state.ideasConfiguration.data && !state.ideasConfiguration.error;
}

// Themes
const AddThemeActionType = 'canny/ideasConfiguration/addTheme';
export const addThemeToConfiguration = (theme: IdeaTheme): AddThemeAction => {
  return {
    type: AddThemeActionType,
    theme,
    timestamp: Date.now(),
  };
};

export { AddThemeActionType, ErrorType, LoadedType, RequestType };

export type AddThemeAction = {
  type: typeof AddThemeActionType;
  theme: IdeaTheme;
  timestamp: number;
};
